import { Link } from "react-router-dom";
import { articles, categories } from "@/mocks/content";

export default function HotRanking() {
  const hotList = [...articles].sort((a, b) => b.views - a.views).slice(0, 7);
  const featured = hotList[0];
  const rest = hotList.slice(1);

  return (
    <section id="hot" className="w-full px-4 md:px-8 py-14 md:py-20">
      <div className="flex items-end justify-between mb-8">
        <div>
          <span className="text-xs md:text-sm text-primary-700 font-medium">今日热度</span>
          <h2 className="font-heading text-2xl md:text-3xl font-black text-foreground-950 mt-1">
            热料榜
          </h2>
        </div>
        <p className="hidden sm:block text-sm text-foreground-500">按浏览量实时排序，每隔一段时间刷新</p>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <article className="group">
          <Link to={`/article/${featured.id}`} className="block cursor-pointer">
            <div className="w-full aspect-[16/10] rounded-lg overflow-hidden bg-background-100">
              <img
                src={featured.cover}
                alt={`${featured.title} - 看料91 热料榜首位内容`}
                title={`${featured.title} 看料91`}
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
              />
            </div>
            <div className="mt-4 flex items-center gap-2">
              <span className="text-xs px-2 py-0.5 rounded-full bg-primary-500 text-background-50">
                榜首
              </span>
              <span className="text-xs px-2 py-0.5 rounded-full bg-accent-100 text-accent-900">
                {categories.find((c) => c.slug === featured.categorySlug)?.name}
              </span>
            </div>
            <h3 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 mt-3 group-hover:text-primary-700 transition-colors">
              {featured.title}
            </h3>
            <p className="text-sm text-foreground-600 mt-2 line-clamp-2">{featured.excerpt}</p>
            <div className="flex items-center gap-4 mt-3 text-xs text-foreground-500">
              <span>{featured.date}</span>
              <span className="flex items-center gap-1">
                <span className="w-3.5 h-3.5 flex items-center justify-center">
                  <i className="ri-fire-fill text-sm" />
                </span>
                {featured.views.toLocaleString("zh-CN")} 次浏览
              </span>
            </div>
          </Link>
        </article>

        <div className="bg-background-100 rounded-lg p-4 md:p-6">
          {rest.map((a, i) => (
            <Link
              key={a.id}
              to={`/article/${a.id}`}
              className="group flex items-start gap-4 py-4 border-b border-background-200 last:border-b-0 cursor-pointer"
            >
              <span
                className={`w-7 h-7 flex-shrink-0 flex items-center justify-center rounded-md font-heading font-bold text-sm mt-0.5 ${
                  i < 2 ? "bg-primary-500 text-background-50" : "bg-background-300 text-foreground-700"
                }`}
              >
                {i + 2}
              </span>
              <div className="flex-1 min-w-0">
                <h3 className="text-sm md:text-base font-medium text-foreground-900 line-clamp-2 group-hover:text-primary-700 transition-colors">
                  {a.title}
                </h3>
                <div className="flex items-center gap-3 mt-1.5 text-xs text-foreground-500">
                  <span className="text-secondary-700">
                    {categories.find((c) => c.slug === a.categorySlug)?.name}
                  </span>
                  <span>{a.views.toLocaleString("zh-CN")} 浏览</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}